<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="1100">
      <template v-slot:activator="{ on }">
        <v-btn v-if="button_name" color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text class="pt-5 pb-2">
            <v-row>
              <v-col cols="12" md="4">
                <v-combobox
                  v-model="item.emitter"
                  data-vv-as="emisor"
                  name="emitter"
                  item-text="name"
                  item-value="id"
                  :items="emitters"
                  label="Emisor*"
                  autocomplete="off"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal() || item.id > 0"
                  return-object
                  @change="changeEmitter"
                ></v-combobox>
                <span class="red--text caption">{{ errors.first("emitter") }}</span>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-as="descripción"
                  label="Descripción*"
                  name="description"
                  v-model="item.description"
                  v-validate="'required|max:255'"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text caption">{{ errors.first("description") }}</span>
              </v-col>

              <v-col cols="12" md="2">
                <v-checkbox v-model="item.enabled" label="Habilitada" :disabled="isViewModal()"></v-checkbox>
              </v-col>
            </v-row>

            <!-- Detalles Contables -->
            <div class="d-flex justify-space-between align-center mt-3 mb-3">
              <div class="d-flex align-center">
                <v-icon color="#1565C0" class="mr-2" size="20">format_list_bulleted</v-icon>
                <span class="subtitle-1 font-weight-bold grey--text text--darken-3">Detalles Contables</span>
              </div>
              <v-btn v-if="!isViewModal()" color="primary" small @click="addItem">
                <v-icon small left>add</v-icon>
                Agregar Item
              </v-btn>
            </div>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="detail-th">#</th>
                    <th class="detail-th">Cuenta</th>
                    <th class="detail-th">Concepto</th>
                    <th class="detail-th">Centro de Costo</th>
                    <th class="detail-th" v-if="!isViewModal()"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(templateItem, index) in item.items" :key="index">
                    <td class="text-center grey--text text--darken-1" style="min-width:40px; font-size:13px; font-weight:500">
                      {{ String(index + 1).padStart(2, '0') }}
                    </td>
                    <td style="min-width:240px">
                      <v-combobox
                        v-model="templateItem.account"
                        item-text="label"
                        item-value="id"
                        :items="accountsImputables"
                        autocomplete="off"
                        hide-details
                        :disabled="isViewModal()"
                        return-object
                        class="py-1"
                      ></v-combobox>
                    </td>
                    <td style="min-width:180px">
                      <v-combobox
                        v-if="esResultado(templateItem)"
                        v-model="templateItem.concepto"
                        item-text="name"
                        item-value="id"
                        :items="conceptos"
                        autocomplete="off"
                        hide-details
                        clearable
                        :disabled="isViewModal()"
                        return-object
                        class="py-1"
                      ></v-combobox>
                      <span v-else class="grey--text caption">—</span>
                    </td>
                    <td style="min-width:180px">
                      <v-combobox
                        v-if="esResultado(templateItem)"
                        v-model="templateItem.cost_center"
                        item-text="name"
                        item-value="id"
                        :items="cost_centers"
                        autocomplete="off"
                        hide-details
                        clearable
                        :disabled="isViewModal()"
                        return-object
                        class="py-1"
                      ></v-combobox>
                      <span v-else class="grey--text caption">—</span>
                    </td>
                    <td v-if="!isViewModal()" style="width:40px">
                      <v-icon color="red lighten-1" small @click="removeItem(index)">delete</v-icon>
                    </td>
                  </tr>
                  <tr v-if="item.items.length === 0">
                    <td colspan="5" class="text-center grey--text py-4">Sin ítems — hacé click en "Agregar Item"</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ConstantSections from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
    emitters: Array,
  },
  data() {
    return {
      accounts: [],
      cost_centers: [],
      conceptos: [],
    };
  },
  computed: {
    accountsImputables() {
      return this.accounts.filter((a) => a.imputable);
    },
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog(val) {
      this.errors.clear();
      this.$validator.reset();
      if (val) {
        this.loadAccounts();
        if (!this.item.items || this.item.items.length === 0) {
          this.item.items = [];
          this.addItem();
        }
      }
    },
  },
  mounted() {
    generalService.filter({ enabled: true }, ConstantSections.SECTION_COSTS_CENTERS).then((response) => {
      this.cost_centers = (response.result || []).map((cc) => ({ id: cc.id, name: cc.name }));
    });
    generalService.filter({ enabled: true }, ConstantSections.SECTION_CONCEPTOS).then((response) => {
      this.conceptos = (response.result || []).map((k) => ({ id: k.id, name: k.name }));
    });
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    esResultado(templateItem) {
      return templateItem.account != null && templateItem.account.is_resultado === true;
    },
    addItem() {
      this.item.items.push({ id: 0, account: null, cost_center: null, concepto: null });
    },
    removeItem(index) {
      this.item.items.splice(index, 1);
    },
    //Las cuentas son por emisor: al cambiarlo se descartan las ya elegidas
    changeEmitter() {
      this.item.items.forEach((i) => {
        i.account = null;
        i.concepto = null;
        i.cost_center = null;
      });
      this.loadAccounts();
    },
    loadAccounts() {
      if (!this.item.emitter || !this.item.emitter.id) {
        this.accounts = [];
        return;
      }
      generalService.filter({ emitter: this.item.emitter.id }, ConstantSections.SECTION_ACCOUNTS).then((response) => {
        this.accounts = response.result || [];
      });
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          const itemsValidos = this.item.items.filter((i) => i.account != null && i.account.id);
          if (itemsValidos.length === 0) {
            this.$toast.error("La plantilla debe tener al menos un ítem con cuenta.", "Error");
            return;
          }

          this.loading = true;
          this.service.setSection(ConstantSections.SECTION_ASIENTO_TEMPLATES);

          const payload = {
            id: this.item.id || null,
            description: this.item.description,
            enabled: this.item.enabled,
            emitter: this.item.emitter ? { id: this.item.emitter.id } : null,
            items_arr: itemsValidos.map((i) => ({
              id: i.id || 0,
              account: { id: i.account.id },
              cost_center: i.cost_center ? { id: i.cost_center.id } : null,
              concepto: i.concepto ? { id: i.concepto.id } : null,
            })),
          };

          const call = this.item.id > 0 ? this.service.update(payload) : this.service.create(payload);
          call
            .then((response) => {
              if (response.status == true) {
                const verb = this.item.id > 0 ? "modifico" : "creo";
                this.$toast.success("La plantilla se " + verb + " correctamente.", "OK");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                this.$toast.error(response.msg || response.message, "Error");
              }
            })
            .catch(() => {
              this.$toast.error("Ocurrió un error al guardar.", "Error");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>

<style scoped>
.detail-th {
  background-color: #F5F5F5 !important;
  color: #616161 !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
